module.exports = __webpack_public_path__ + "media/images/e-bilet/Hero_Image_Kyiv_720-3325eb31dc40a289b8d7adc999af7792.jpg";